export default __webpack_public_path__ + "static/media/oil-pump.a8f11ec2.png";